
import React from 'react';
import Layout from '@/components/Layout/Layout';
import TemperatureConverter from '@/components/UnitConverter/TemperatureConverter';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const TemperatureConverterPage = () => {
  return (
    <Layout>
      <div className="container mx-auto max-w-3xl px-4">
        <div className="mb-6">
          <Link to="/converters" className="flex items-center text-primary hover:underline mb-2">
            <ArrowLeft size={16} className="mr-1" />
            Back to All Converters
          </Link>
          <h1 className="text-3xl font-bold mb-2">Temperature Converter</h1>
          <p className="text-gray-600 mb-6">
            Convert between Celsius, Fahrenheit, Kelvin and other temperature scales.
          </p>
        </div>
        
        <div className="mb-8">
          <TemperatureConverter />
        </div>
        
        <div className="mt-10 prose max-w-none">
          <h2 className="text-xl font-semibold mb-4">About Temperature Converter</h2>
          <p>
            Our temperature converter allows you to easily convert between different temperature scales 
            including Celsius (°C), Fahrenheit (°F), Kelvin (K), and more. Whether you're cooking, 
            working with scientific data, or just curious about weather reports from different countries, 
            our converter provides quick and accurate temperature conversions.
          </p>
          
          <h3 className="text-lg font-medium mt-6 mb-2">Common Temperature Conversions</h3>
          <p>
            Some of the most frequently used temperature conversions include:
          </p>
          <ul className="list-disc ml-6">
            <li>Converting between Celsius and Fahrenheit (everyday use)</li>
            <li>Converting to Kelvin (scientific applications)</li>
            <li>Converting between Celsius and Rankine</li>
            <li>Finding freezing and boiling points across different scales</li>
          </ul>
          
          <h3 className="text-lg font-medium mt-6 mb-2">How to Use the Temperature Converter</h3>
          <p>
            Using our temperature converter is straightforward:
          </p>
          <ol className="list-decimal ml-6">
            <li>Enter the temperature value in the "From" field</li>
            <li>Select the temperature scale you're converting from</li>
            <li>Select the temperature scale you want to convert to</li>
            <li>The converted temperature will appear automatically</li>
          </ol>
          
          <h3 className="text-lg font-medium mt-6 mb-2">Quick Reference</h3>
          <p>
            Here are some common temperature reference points:
          </p>
          <ul className="list-disc ml-6">
            <li>Water freezes at 0°C / 32°F / 273.15K</li>
            <li>Water boils at 100°C / 212°F / 373.15K (at standard pressure)</li>
            <li>Room temperature is typically around 20-22°C / 68-72°F</li>
            <li>Body temperature is approximately 37°C / 98.6°F</li>
          </ul>
        </div>
      </div>
    </Layout>
  );
};

export default TemperatureConverterPage;
